import { cva } from 'class-variance-authority'

export const rootVariants = cva(
  'flex h-4 w-4 pointer-events-none flex-shrink-0 items-center justify-center rounded-md outline-none transition-colors duration-100',
  {
    variants: {
      isChecked: {
        true: 'bg-blue-500',
        false: 'ring-2 ring-inset ring-default group-hover/item:ring-emphasis',
      },
      isDisabled: {
        true: 'opacity-50',
        false: '',
      },
    },
    compoundVariants: [
      {
        isDisabled: true,
        isChecked: false,
        className: 'ring-default group-hover/item:ring-default',
      },
    ],
  },
)
